module.exports = __webpack_public_path__ + "static/img/share.a987f36c.png";